import { css } from '@emotion/css';

export const swapStyle = css`
  transform: rotate(-90deg);
`;
